export default "__VITE_ASSET__Dk9egm$f__"